module.exports = __webpack_public_path__ + "img/ryan.f3fba48f.jpg";